import styles from "./FeatureList.module.css";

export default function FeatureList({ items, columns = 3 }) {
  return (
    <ul className={`grid grid-${columns} ${styles.list}`}>
      {items.map((item) => (
        <li key={item.title} className={styles.item}>
          <h3 className={styles.title}>{item.title}</h3>
          <p className={styles.text}>{item.text}</p>
        </li>
      ))}
    </ul>
  );
}
